module.exports = __webpack_public_path__ + "static/media/thumbnail.da29aad7.jpg";